// Hero carousel
function hero() {
  document.addEventListener("DOMContentLoaded", () => {
    const items = document.querySelectorAll(".js-carousel-item");
    let currentIndex = 0;

    if (items.length > 1) {
      setInterval(() => {
        items[currentIndex].classList.remove("active");
        currentIndex = (currentIndex + 1) % items.length;
        items[currentIndex].classList.add("active");
      }, 5000); // Change image every 5 seconds
    }
  });
}

export { hero };
